import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { XlsxImportRevisionPlanPayload } from 'api/actions/xlsx-import-revision-plan/xlsx-import-revision-plan-payload';
import { XlsxImportRevisionPlanPathParameters } from 'api/actions/xlsx-import-revision-plan/xlsx-import-revision-plan-path-parameters';
import { XlsxImportRevisionPlanResponse } from 'api/actions/xlsx-import-revision-plan/xlsx-import-revision-plan-response';

type XlsxImportRevisionPlanQueryParameters = Record<string, any>;

/**
 * The path of the XlsxImportRevisionPlan action.
 */
export const xlsxImportRevisionPlanActionPath = new SweetPath<keyof XlsxImportRevisionPlanPathParameters>(
  '/api/xlsx/import-revision-plan',
  { path: '{param}' }
);

/**
 * Creates a contextualized XlsxImportRevisionPlan actions.
 */
export default function createXlsxImportRevisionPlanAction(axios: AxiosInstance) {
  return function xlsxImportRevisionPlanAction({
    headers = {},
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    query?: XlsxImportRevisionPlanQueryParameters;
    payload: XlsxImportRevisionPlanPayload;
  }) {
    const path = xlsxImportRevisionPlanActionPath.original;

    return axios.request<XlsxImportRevisionPlanResponse, XlsxImportRevisionPlanResponse>({
      method: 'post',
      url: path,
      params: query,
      data: payload,
      headers,
    });
  };
}
